import { call, takeLeading } from "starfx";

import { schema } from "../schema";
import { xThunk } from "../xapis";
import { fetchDatabaseInWorker } from "./ds";

import type { Next, ThunkCtx } from "starfx";
const db = schema;

export const sfxGetSpvMessages = xThunk.create(
  "/sfx/getSpvMessages",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    yield* call(
      fetchDatabaseInWorker.run({
        postBack: true,
        workerEndpoint: "fetchspvrelated",
        pbkType: "PBK_ALWAYS",
      })
    );
    yield* next();
  }
);
